import React, {useState} from 'react'
import {FaBars, FaTimes} from 'react-icons/fa'
import {Link} from 'react-scroll';

const NavBar = () => {

  const [nav, setNav] = useState(false)

  const links = [
    {
      id: 1,
      link: 'home',
    },
/*     {
      id: 2,
      link: 'about',
    }, */
    {
      id: 3,
      link: 'portfolio',
    },
    {
      id: 4,
      link: 'prices',
    },
    {
      id: 5,
      link: 'contact',
    },
  ]

  return (
    <nav
      className="fixed z-50 flex h-20 w-full items-center justify-between bg-black px-4 text-white"
      aria-label="Main navigation"
    >
      <div>
        <h1 className='ml-2 font-title text-4xl sm:text-5xl'>...Rhea Antonucci...</h1>
        <h2 className='ml-2 grid justify-items-center text-sm' >MakeUp Artist</h2>
      </div>
      
      <ul className='hidden md:flex'>
        {links.map(({id, link}) =>         
        <li key={id} className='px-4 cursor-pointer capitalize 
        font-medium text-gray-500 hover:scale-105 duration-200'
        >
          <Link to={link} smooth duration={500} offset={-80}>{link}</Link>
        </li> )}
      </ul>

      <button
        type="button"
        onClick={() => setNav(!nav)}
        className='z-10 cursor-pointer pr-4 text-gray-500 md:hidden'
        aria-label={nav ? 'Close navigation menu' : 'Open navigation menu'}
        aria-expanded={nav}
      >
        {nav ? <FaTimes size={30} /> : <FaBars size={30} />}
      </button>

      {nav && (
        <ul className='flex flex-col justify-center 
        absolute top-0 left-0 w-full h-screen bg-gradient-to-b
        from-black to-gray-800 text-gray-500 items-center'>
        {links.map(({id, link}) =>         
          <li key={id} className='px-4 cursor-pointer capitalize py-6 text-4xl'
          >
            <Link to={link} smooth duration={500} offset={-80} onClick={() => setNav(false)}>{link}</Link>
          </li>
          )}
        </ul>
      )}
    </nav>
  )
}

export default NavBar
